import { FormInputDropdown } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { getSearchFilterOptions } from 'app/services/SharedServices/SharedServices';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsEditMod, selectIsUndoModal, selectStandard } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { dataSorting, findKeyBaseOnValue, formatTypeAheadOptions } from '../../ModificationsUtils';

export const BonusType = ({ readOnly }: { readOnly?: boolean }) => {
  const { control, getValues, setValue, clearErrors, setError, register } = useFormContext();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isUndoModal = useSelector(selectIsUndoModal);
  const bonusType = 'bonusType';
  register('bonusTypeId');
  const isModEdit = useSelector(selectIsEditMod);
  const standard = useSelector(selectStandard);
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const [bonusTypeOptions, setBonusTypeOptions] = useState([]);

  const getBonusTypeDropDown = async () => {
    const options = await getSearchFilterOptions('bonusType');

    if (options?.length > 0) {
      const newOptions = formatTypeAheadOptions(options);
      setBonusTypeOptions(newOptions);

      if (getValues(bonusType)) {
        const selectedOption = findKeyBaseOnValue(newOptions, getValues(bonusType));

        setValue('bonusTypeId', selectedOption?.id);
        clearErrors(bonusType);
      } else {
        setError(bonusType, {});
      }
      if (isUndoModal) {
        dispatch(placementModsAction.setIsUndoModal(false));
      }
    }
  };

  const getBonusTypeId = (value: string) => {
    const selectedOption = findKeyBaseOnValue(bonusTypeOptions, value);
    return selectedOption?.id;
  };

  const handleChange = (value?: string) => {
    setValue(bonusType, value);
    setValue('bonusTypeId', getBonusTypeId(value));
    if (value) {
      clearErrors(bonusType);
    }
  };

  useEffect(() => {
    getBonusTypeDropDown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUndoModal]);

  return (
    <Controller
      control={control}
      name={bonusType}
      rules={{
        required: true,
      }}
      render={({ field: { onChange, value, ...rest } }) => (
        <FormInputDropdown
          useMenuItem={true}
          name={bonusType}
          label={`${t('placement.placementMods.bonusType')} *`}
          standard={true}
          options={dataSorting(bonusTypeOptions) ?? []}
          handleChange={e => {
            handleChange(e.target.value);
            onChange(e.target.value);
          }}
          {...rest}
          disabled={isSaveModApiCalling}
          inputValue={getValues(bonusType) ?? ''}
          readOnly={readOnly !== undefined ? readOnly : (standard ? standard : !isModEdit)}
        ></FormInputDropdown>
      )}
    />
  );
};
